import { HoverCard, Stack, Text, ThemeIcon } from "@mantine/core";
import { IconClick, IconEye } from "@tabler/icons-react";
import { parseDate } from "../../../../../../../functions/dates";
import { useLanguage } from "../../../../../../../stores/LanguageStore";

const EmailStatus = ({ opens, clicks, isMobile }) => {
  const lang = useLanguage((s) => s.language);

  return (
    <>
      {opens.length > 0 && (
        <HoverCard zIndex={300} position="top">
          <HoverCard.Target>
            <Text size={isMobile ? "xs" : "sm"} color="green" mx={16}>
              {opens.length} {lang.prm.scoring.list.open}
            </Text>
          </HoverCard.Target>

          <HoverCard.Dropdown>
            <Stack px={"sm"}>
              {opens.map((item) => (
                <li key={item.date}>
                  {lang.prm.scoring.list.open} :{" "}
                  {item.date && parseDate(item.date, false)}{" "}
                </li>
              ))}
            </Stack>
          </HoverCard.Dropdown>
        </HoverCard>
      )}

      {clicks.length > 0 && (
        <HoverCard zIndex={300} position="top">
          <HoverCard.Target>
            <Text size={isMobile ? "xs" : "sm"} color="green">
              {clicks.length} {lang.prm.scoring.list.link_click}
            </Text>
          </HoverCard.Target>

          <HoverCard.Dropdown>
            <Stack px={"sm"}>
              {clicks.map((item) => (
                <li key={item.date}>
                  {lang.prm.scoring.list.link_click} :{" "}
                  {item.date && parseDate(item.date, false)}{" "}
                </li>
              ))}
            </Stack>
          </HoverCard.Dropdown>
        </HoverCard>
      )}
    </>
  );
};

export default EmailStatus;
